import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={45}
    height={45}
    fill="none"
    {...props}
  >
    <g>
      <path
        fill="#FF6E58"
        d="M22.89 8.626c7.777 0 14.079 6.302 14.079 14.08 0 7.776-6.302 14.078-14.08 14.078-7.776 0-14.078-6.302-14.078-14.079 0-7.777 6.302-14.079 14.079-14.079Z"
      />
      <path
        fill="#00E9BA"
        d="M22.61 44.687C10.49 44.687.63 34.822.63 22.705.629 10.588 10.489.723 22.61.723s21.982 9.86 21.982 21.982-9.86 21.982-21.982 21.982Zm0-40.487C12.41 4.2 4.107 12.498 4.107 22.705c0 10.208 8.303 18.505 18.505 18.505 10.202 0 18.505-8.303 18.505-18.505 0-10.202-8.303-18.505-18.505-18.505Z"
      />
      <path
        fill="#fff"
        d="m26.07 20.04-3.18-7.887-3.185 7.888-7.883 3.18 7.883 3.184 3.185 7.888 3.18-7.887 7.888-3.185-7.888-3.18Z"
      />
    </g>
  </svg>
)
export default SvgComponent
